import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import CIDataImportFormContainer from '../../../../containers/projects/CIDataImportFormContainer.jsx';

const ChangeImpactDataImport = ({ projectId }) => (
  <>
    <Helmet>
      <title>Change Impact Data Import | ChangeSync</title>
    </Helmet>

    <CIDataImportFormContainer projectId={projectId} />
  </>
);

ChangeImpactDataImport.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(ChangeImpactDataImport));
